import Head from "next/head"
import MainLayout from "src/layouts/mainLayout"
import { getIsSsrMobile } from "src/utils/getIsSsrMobile"
import DashboardLayout from "./components/DashboardLayout"
import DesktopWrapper from "src/components/layout/desktop/desktop-wrapper"

const DashboardPage = () => {
  return (
    <>
      <Head>
        <title>پنل کاربری</title>
      </Head>
      <DesktopWrapper title='پنل کاربری'>
        <DashboardLayout />
      </DesktopWrapper>
    </>
  )
}

DashboardPage.Layout = MainLayout

export default DashboardPage

export async function getServerSideProps(context) {
  return {
    props: {
      isSsrMobile: getIsSsrMobile(context)
    }
  }
}
